const o = (t) => ({
  wrapper: {
    backgroundColor: t.palette.common.white
  },
  title: {
    color: t.palette.common.blue400,
    "@media(max-width: 600px)": {
      textAlign: "center",
      fontSize: t.typography.fontSize22
    }
  },
  description: {
    fontSize: t.typography.fontSize18,
    "@media(max-width: 600px)": {
      fontSize: t.typography.fontSize14
    }
  },
  contactTitle: {
    color: t.palette.common.blue400,
    fontSize: t.typography.fontSize18
  },
  listItem: {
    padding: "4px 0px"
  },
  listItemText: {
    color: t.palette.common.blue400
  },
  quoteBtn: {
    maxWidth: 260,
    "@media(max-width: 600px)": {
      maxWidth: "100%"
    }
  },
  arabicText: {
    direction: "rtl",
    unicodeBidi: "embed"
  }
}), i = o;
export {
  i as default
};
